import styled from 'styled-components'
import { margin, MarginProps } from 'styled-system'

import Icon from '../Icon'
import Text from '../Text'
import Box from '../Box'

export type Variant = 'pill' | 'badge'

export interface ChipProps extends MarginProps {
  bordered?: boolean
  children: string
  onDismiss?: () => void
  variant?: Variant
  isEditable?: boolean
}

const Chip = ({ bordered = true, children, onDismiss, variant = 'pill', isEditable = true }: ChipProps) => (
  <Container bordered={bordered} chipVariant={variant} hasDismiss={!!onDismiss}>
    <Box>
      <Text>{children}</Text>
    </Box>
    {onDismiss && isEditable && (
      <>
        {variant === 'pill' ? (
          <CloseButton color="red" fontSize={18} icon={['fas', 'times-circle']} onClick={onDismiss} />
        ) : (
          <Icon fontSize={14} icon={['far', 'times']} color="gray5" onClick={onDismiss} />
        )}
      </>
    )}
  </Container>
)

const Container = styled.div<MarginProps & { bordered?: boolean; chipVariant: Variant; hasDismiss: boolean }>`
  ${margin}
  display: flex;
  position: relative;
  align-items: center;
  justify-content: center;
  user-select: none;
  min-width: 2rem;
  min-height: 1rem;
  width: max-content;
  height: max-content;
  background-color: ${(p) => p.theme.colors.gray2};
  border: ${(p) => (p.bordered ? `1px solid ${p.theme.colors.gray4}` : 'none')};
  ${(p) => {
    switch (p.chipVariant) {
      case 'pill':
        return `
          padding: 0.5rem 1.4rem;
          border-radius: 16px;
        `
      case 'badge':
        return `
          padding: 0.5rem 0.7rem;
          border-radius: 4px;
          border: none;
          gap: 0.7rem;
          ${p.hasDismiss ? `padding-right: 0.7rem;` : ``}
        `
      default:
        return ``
    }
  }}
`

const CloseButton = styled(Icon)`
  position: absolute;
  right: -8px;
  top: -8px;
`

export default Chip
